export enum ActivationStatus {
  Activated = 'Activated',
  Deactivated = 'Deactivated',
}
